// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "DM Sans", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap") format("woff");
}
@font-face {
  font-family: "Inter", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap") format("woff");
}
@font-face {
  font-family: "Source Sans Pro", sans-serif;
  src: url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff2"), url("https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap") format("woff");
}
.changePassword_button-group__HBphq {
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center;
  gap: 20px;
  width: 100%;
  margin-top: 16px;
  clear: both;
}
@media (max-width: 767px) {
  .changePassword_button-group__HBphq {
    flex-direction: column;
    gap: 10px;
  }
}

.changePassword_btn__4Mbvz {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 18px;
  font-size: 26px;
  font-weight: 400;
  font-family: "Source Sans Pro", sans-serif;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;
  height: 55px;
}
.changePassword_btn__4Mbvz:disabled {
  cursor: not-allowed;
  opacity: 0.9;
}

.changePassword_cancel-btn__5MArm {
  background: #e6eaef;
  color: #ffffff;
  border-color: #d7dbe0;
  width: 100%;
}
.changePassword_cancel-btn__5MArm:hover:not(:disabled) {
  background: #cfd5df;
  text-decoration: underline;
  border-color: #cbd2d9;
}
.changePassword_cancel-btn__5MArm:disabled {
  background: #e9edf2;
  border-color: #e1e6eb;
}
@media (max-width: 767px) {
  .changePassword_cancel-btn__5MArm {
    padding: 26px;
    font-size: 26px;
    color: #ffffff !important;
    font-weight: 400;
    border: 0 !important;
    margin-bottom: 15px;
  }
}

.changePassword_save-btn__Immee {
  background: #ffa61b;
  color: #ffffff;
  border-color: transparent;
  width: 100%;
}
.changePassword_save-btn__Immee:hover {
  text-decoration: underline;
}
.changePassword_save-btn__Immee:disabled {
  filter: saturate(0.85);
}
@media (max-width: 767px) {
  .changePassword_save-btn__Immee {
    padding: 26px;
    font-size: 26px;
    color: #ffffff !important;
    font-weight: 400;
    border: 0 !important;
    margin-top: 15px;
  }
}

.changePassword_change-password-container__7UeXt {
  background: #f4f5f7;
  border: 1px solid #e0e3e7;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  padding: 24px;
  max-width: 980px;
  color: #3a3a3a;
}
@media (max-width: 767px) {
  .changePassword_change-password-container__7UeXt {
    background: none;
    border: 0;
    box-shadow: none;
    padding: 24px 16px;
  }
}

.changePassword_change-password-title__nYget {
  font-size: 30px;
  font-weight: 300;
  margin: 0 0 8px;
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 300;
  line-height: 1.2;
}

.changePassword_change-password-subtitle__c9ZeL {
  font-size: 16px;
  font-weight: 300;
  color: #6f7a86;
  font-family: "Source Sans Pro", sans-serif;
  margin: 0 0 40px;
}
@media (max-width: 767px) {
  .changePassword_change-password-subtitle__c9ZeL {
    line-height: 1.2;
    margin-bottom: 40px;
  }
}

/* Two columns: form (left) and rules (right) */
.changePassword_change-password-content__gUybQ {
  display: grid;
  grid-template-columns: 1.2fr 0.8fr;
  gap: 32px;
}
@media (max-width: 768px) {
  .changePassword_change-password-content__gUybQ {
    grid-template-columns: 1fr;
  }
}

.changePassword_password-form__bmvQl {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.changePassword_form-group__eoEoq {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.changePassword_form-control__lh7b\\+ {
  background: #ffffff;
  border: 1px solid #d7dbe0;
  border-radius: 0px;
  padding: 8px 16px;
  font-size: 18px;
  font-style: normal;
  color: #3a3a3a;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  font-family: "Source Sans Pro", sans-serif;
}
.changePassword_form-control__lh7b\\+::placeholder {
  color: #9aa6b2;
  font-style: italic;
}
.changePassword_form-control__lh7b\\+:hover {
  border-color: #bfc6ce;
}
.changePassword_form-control__lh7b\\+:focus {
  border-color: #8bb8e6;
  box-shadow: 0 0 0 3px rgba(139, 184, 230, 0.2);
}
@media (max-width: 767px) {
  .changePassword_form-control__lh7b\\+ {
    border-radius: 0;
    padding: 8px 18px;
  }
}

.changePassword_error-text__xB5jB {
  font-size: 12px;
  color: #c62828;
}

.changePassword_password-rules__cLfOj {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 300;
  border-radius: 10px;
  color: #6f7a86;
  font-size: 20px;
  font-style: italic;
}
@media (max-width: 767px) {
  .changePassword_password-rules__cLfOj {
    color: #4f785f;
    line-height: 1.2;
    font-weight: 300;
  }
}
.changePassword_password-rules__cLfOj ul {
  list-style: none;
  padding-left: 1rem;
}
@media (max-width: 767px) {
  .changePassword_password-rules__cLfOj ul {
    padding-top: 5px;
  }
}
.changePassword_password-rules__cLfOj li {
  position: relative;
  padding-left: 18px;
  margin: 0;
  color: #5f8f88;
}
@media (max-width: 767px) {
  .changePassword_password-rules__cLfOj li {
    color: #4f785f;
    line-height: 1.2;
    font-weight: 300;
    margin: 0;
  }
}
.changePassword_password-rules__cLfOj li::before {
  content: "•";
  position: absolute;
  left: 0;
  top: 0;
  color: #4f785f;
  font-weight: 700;
}

.changePassword_button-group__HBphq {
  padding-top: 14px;
  font-family: "Source Sans Pro", sans-serif;
}`, "",{"version":3,"sources":["webpack://./src/styles/myAccount/changePassword.module.scss","webpack://./src/styles/base/_fonts.scss","webpack://./src/styles/abstracts/_variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACOhB;EACE,kCAAA;EACA,oRAAA;ADFF;ACOA;EACE,gCAAA;EACA,wPAAA;ADLF;ACSA;EACE,0CAAA;EACA,wWAAA;ADPF;AAdA;EAEI,wBAAA;EACA,oCAAA;EACA,mBAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;AAeJ;AAdI;EATJ;IAUQ,sBAAA;IACA,SAAA;EAiBN;AACF;;AAdA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBEgHC;EF/GD,0CE0HgB;EFzHhB,6BAAA;EACA,eAAA;EACA,kFAAA;EACA,YAAA;AAiBJ;AAhBI;EACI,mBAAA;EACA,YAAA;AAkBR;;AAdA;EACI,mBAAA;EACA,cEaI;EFZJ,qBAAA;EACA,WAAA;AAiBJ;AAfI;EACI,mBAAA;EACA,0BAAA;EACA,qBAAA;AAiBR;AAdI;EACI,mBAAA;EACA,qBAAA;AAgBR;AAdI;EAhBJ;IAiBQ,aAAA;IACA,eAAA;IACA,yBAAA;IACA,gBEgFH;IF/EG,oBAAA;IACA,mBAAA;EAiBN;AACF;;AAbA;EACI,mBAAA;EACA,cEdI;EFeJ,yBAAA;EACA,WAAA;AAgBJ;AAdI;EAEI,0BAAA;AAeR;AAZI;EACI,sBAAA;AAcR;AAZI;EAdJ;IAeQ,aAAA;IACA,eAAA;IACA,yBAAA;IACA,gBEuDH;IFtDG,oBAAA;IACA,gBAAA;EAeN;AACF;;AAXA;EACI,mBAAA;EACA,yBAAA;EACA,0CAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AAcJ;AAbI;EAPJ;IAQQ,gBAAA;IACA,SAAA;IACA,gBAAA;IACA,kBAAA;EAgBN;AACF;;AAbA;EACI,eAAA;EACA,gBAAA;EACA,eAAA;EACA,0CEwCgB;EFvChB,gBE2BC;EF1BD,gBAAA;AAgBJ;;AAdA;EACI,eAAA;EACA,gBEsBC;EFrBD,cAAA;EACA,0CEgCgB;EF/BhB,gBAAA;AAiBJ;AAhBI;EANJ;IAOQ,gBAAA;IACA,mBAAA;EAmBN;AACF;;AAhBA,+CAAA;AACA;EACI,aAAA;EACA,kCAAA;EACA,SAAA;AAmBJ;AAjBI;EALJ;IAMQ,0BAAA;EAoBN;AACF;;AAjBA;EACI,aAAA;EACA,sBAAA;EACA,SAAA;AAoBJ;;AAjBA;EACI,aAAA;EACA,sBAAA;EACA,QAAA;AAoBJ;;AAjBA;EACI,mBEhGI;EFiGJ,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,0DAAA;EACA,0CETgB;AF6BpB;AAnBI;EACI,cAAA;EACA,kBAAA;AAqBR;AAlBI;EACI,qBAAA;AAoBR;AAjBI;EACI,qBAAA;EACA,8CAAA;AAmBR;AAjBI;EAxBJ;IAyBQ,gBAAA;IACA,iBAAA;EAoBN;AACF;;AAjBA;EACI,eAAA;EACA,cAAA;AAoBJ;;AAhBA;EACI,0CEpCgB;EFqChB,gBEjDC;EFkDD,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAmBJ;AAlBI;EAPJ;IAQQ,cAAA;IACA,gBAAA;IACA,gBEzDH;EF8EH;AACF;AAnBI;EACI,gBAAA;EACA,kBAAA;AAqBR;AApBQ;EAHJ;IAIQ,gBAAA;EAuBV;AACF;AApBI;EACI,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,cAAA;AAsBR;AArBQ;EALJ;IAMQ,cAAA;IACA,gBAAA;IACA,gBE5EP;IF6EO,SAAA;EAwBV;AACF;AAtBQ;EACI,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,cAAA;EACA,gBAAA;AAwBZ;;AAlBA;EACI,iBAAA;EACA,0CElFgB;AFuGpB","sourcesContent":["@use '../abstracts/variables' as *;\n.button-group {\n   \n    display: flex !important;\n    justify-content: flex-end !important; \n    align-items: center;\n    gap: 20px; \n    width: 100%; \n    margin-top: 16px;\n    clear: both;\n    @media (max-width: 767px) {\n        flex-direction: column;\n        gap: 10px\n    }   \n}\n\n.btn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 12px 18px;\n    font-size: 26px;\n    font-weight: $fw4;\n    font-family: $source-sans-pro;\n    border: 1px solid transparent;\n    cursor: pointer;\n    transition: background-color 0.15s ease, color 0.15s ease, border-color 0.15s ease;\n    height: 55px;\n    &:disabled {\n        cursor: not-allowed;\n        opacity: 0.9;\n    }\n}\n\n.cancel-btn {\n    background: #e6eaef;\n    color: $white;\n    border-color: #d7dbe0;\n    width: 100%;\n    \n    &:hover:not(:disabled) {\n        background: #cfd5df;\n        text-decoration: underline;\n        border-color: #cbd2d9;\n    }\n\n    &:disabled {\n        background: #e9edf2;\n        border-color: #e1e6eb;\n    }\n    @media (max-width: 767px) {\n        padding: 26px;\n        font-size: 26px;\n        color: $white !important;\n        font-weight: $fw4;\n        border:0 !important;\n        margin-bottom:15px;\n    }\n}\n\n\n.save-btn {\n    background: #ffa61b;\n    color: $white;\n    border-color: transparent;\n    width: 100%;\n\n    &:hover\n    {\n        text-decoration: underline;\n    }\n\n    &:disabled {\n        filter: saturate(0.85);\n    }\n    @media (max-width: 767px) {\n        padding: 26px;\n        font-size: 26px;\n        color: $white !important;\n        font-weight: $fw4;\n        border:0 !important;\n        margin-top:15px;\n    }\n}\n\n\n.change-password-container {\n    background: #f4f5f7;\n    border: 1px solid #e0e3e7;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);\n    padding: 24px;\n    max-width: 980px;\n    color: #3a3a3a;\n    @media (max-width: 767px) {\n        background: none;\n        border: 0;\n        box-shadow: none;\n        padding: 24px 16px;\n    } \n}\n\n.change-password-title {\n    font-size: 30px;\n    font-weight: 300;\n    margin: 0 0 8px;\n    font-family: $source-sans-pro;\n    font-weight: $fw3;\n    line-height: 1.2;\n}\n.change-password-subtitle {\n    font-size: 16px;\n    font-weight: $fw3;\n    color: #6f7a86;\n    font-family: $source-sans-pro;\n    margin: 0 0 40px;\n    @media (max-width: 767px) {\n        line-height: 1.2;\n        margin-bottom: 40px;\n    }\n}\n\n/* Two columns: form (left) and rules (right) */\n.change-password-content {\n    display: grid;\n    grid-template-columns: 1.2fr 0.8fr;\n    gap: 32px;\n\n    @media (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n}\n\n.password-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.form-control {\n    background: $white;\n    border: 1px solid #d7dbe0;\n    border-radius: 0px;\n    padding: 8px 16px;\n    font-size: 18px;\n    font-style: normal;\n    color: #3a3a3a;\n    outline: none;\n    transition: border-color 0.15s ease, box-shadow 0.15s ease;\n    font-family: $source-sans-pro;\n    &::placeholder {\n        color: #9aa6b2;\n        font-style: italic;\n    }\n\n    &:hover {\n        border-color: #bfc6ce;\n    }\n\n    &:focus {\n        border-color: #8bb8e6;\n        box-shadow: 0 0 0 3px rgba(139, 184, 230, 0.2);\n    }\n    @media (max-width: 767px) {\n        border-radius: 0;\n        padding: 8px 18px;\n    }\n}\n\n.error-text {\n    font-size: 12px;\n    color: #c62828;\n}\n\n\n.password-rules {\n    font-family: $source-sans-pro;\n    font-weight: $fw3;\n    border-radius: 10px;\n    color: #6f7a86;\n    font-size: 20px;\n    font-style: italic;\n    @media (max-width: 767px) {\n        color: #4f785f;\n        line-height: 1.2;\n        font-weight: $fw3;\n    }\n\n    ul {\n        list-style: none;\n        padding-left: 1rem;\n        @media (max-width: 767px) {\n            padding-top: 5px;\n        }\n    }\n\n    li {\n        position: relative;\n        padding-left: 18px;\n        margin: 0;\n        color: #5f8f88;\n        @media (max-width: 767px) {\n            color: #4f785f;\n            line-height: 1.2;\n            font-weight: $fw3;\n            margin: 0;\n        }\n\n        &::before {\n            content: \"•\";\n            position: absolute;\n            left: 0;\n            top: 0;\n            color: #4f785f;\n            font-weight: 700;\n        }\n    }\n}\n\n\n.button-group {\n    padding-top: 14px;\n    font-family: $source-sans-pro;\n}","// -----------------------------------------------------------------------------\n// This file contains all @font-face declarations, if any.\n// -----------------------------------------------------------------------------\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap');\n@import url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap');\n\n@font-face {\n  font-family: \"DM Sans\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff2'),\n  url('https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&display=swap') format('woff');\n  \n}\n\n@font-face {\n  font-family: \"Inter\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@200;300;400;600;700&amp;display=swap') format('woff');\n}\n\n@font-face {\n  font-family: \"Source Sans Pro\", sans-serif;\n  src: url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff2'),\n       url('https://fonts.googleapis.com/css2?family=Source+Code+Pro:ital,wght@0,200..900;1,200..900&family=Source+Sans+3:ital,wght@0,200..900;1,200..900&display=swap') format('woff');\n}","// -----------------------------------------------------------------------------\n// This file contains all application-wide Sass variables.\n// -----------------------------------------------------------------------------\n\n\n//Fonts \n\n\n@import \"../base/fonts\";\n\n\n$roboto-regular : 'Roboto-regular';\n$roboto-bold: 'Roboto-bold';\n$roboto-medium: 'Roboto-medium';\n$roboto-light-italic: 'Roboto-light-italic';\n\n/// Regular font family\n/// @type List\n//$text-font-stack: 'Open Sans', 'Helvetica Neue Light', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif !default;\n\n/// Code (monospace) font family\n/// @type List\n//$code-font-stack: 'Courier New', 'DejaVu Sans Mono', 'Bitstream Vera Sans Mono', 'Monaco', monospace !default;\n\n\n\n\n\n/// Copy text color\n/// @type Color\n$text-color: rgb(34, 34, 34) !default;\n\n/// Main brand color\n/// @type Color\n$brand-color: rgb(229, 0, 80) !default;\n\n/// Light grey\n/// @type Color\n$light-grey: rgb(237, 237, 237) !default;\n\n/// Medium grey\n/// @type Color\n$mid-grey: rgb(153, 153, 153) !default;\n\n/// Dark grey\n/// @type Color\n$dark-grey: rgb(68, 68, 68) !default;\n\n$black: #000000;\n$white: #ffffff;\n$gray: #222222;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n\n$hover-grey: #b8babf;\n$gray7:#333333;\n$gray8:#CCCCCC;\n$gray9:#dddddd;\n$gray10:#57606a;\n$gray11:#999999;\n$light-gray : #414141;\n$light-gray2 : #666666;\n$gray2 : #4F4F4F;\n$grey3 : #939393;\n$grey4 : #1c1c1c;\n$grey5 : #9e9e9e;\n$grey6 : #858585;\n$grey7 : #d9d9d9;\n$grey8 : #e6e9ee;\n$grey9 : #e6e6e9;\n$hover-grey: #b8babf;\n$stone : #CACACA;\n$gray-bg :#EBF9F0;\n$green:#046A38;\n$green2:#1EE576;\n$green3:#19C063;\n$green5:#2a8056;\n$green4:#73c573;\n$green7:#70c66f;\n$dark-green:#00873C;\n$light-green:#00B140;\n$light-green1 : #4f785f;\n$red : #FF0000;\n$light-red:#ff3c3c;\n$yellow:#FFB034;\n$dark-yellow:#e2a014;\n$yellow-hover:#cd7d00;\n$blue :#0A1AB4;\n$orange:#EA6B1F;\n$purple:#6A1B85;\n$offwhite:#F5F7F5;\n$offwhite1:#E0E0E0;\n$bg-grey-login:#f2f3f6;\n$border-grey: #ced4da;\n$bl-grey: #6c757d;\n$bl-green:#00703c;\n$bl-darkgrey: #b0b0b0;\n$bg-white1:#F5F5F5;\n$bg-white2:#FAFAFA;\n$red1: #d1002f;\n\n$yellow-hover:#cd7d00;\n\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$margin0:0px;\n$margin10:10px;\n$margin15:15px; \n$margin20:20px;\n$margin30:30px; \n$margin40:40px;\n$margin50:50px;\n$margin60:60px;\n\n$padding0:0px;\n$padding10:10px;\n$padding15:15px;    \n$padding16:16px;    \n$padding20:20px;\n$padding30:30px;  \n$padding40:40px;\n$padding50:50px;\n\n$br-0:0px;\n\n$br-0:0px;\n$fw1:100;\n$fw2:200;\n$fw3:300;\n$fw4:400;\n$fw5:500;\n$fw6:600;\n$fw7:700;\n$fw8:800;\n$fw9:900;\n\n$font-dm: \"DM Sans\", sans-serif;\n$font-inter: Inter;\n$font-inter-ss: \"Inter\", sans-serif;\n\n$source-sans-pro:   \"Source Sans Pro\" , sans-serif ;\n\n/// Container's maximum width\n/// @type Length\n$max-width: 1180px !default;\n\n\n\n\n\n/// Breakpoints map\n/// @prop {String} keys - Keys are identifiers mapped to a given length\n/// @prop {Map} values - Values are actual breakpoints expressed in pixels\n$breakpoints: (\n  'small': 320px,\n  'medium': 768px,\n  'large': 1024px,\n) !default;\n\n\n\n\n\n\n/// Relative or absolute URL where all assets are served from\n/// @type String\n/// @example scss - When using a CDN\n///   $base-url: 'https://cdn.example.com/assets/';\n$base-url: '/assets/' !default;\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button-group": `changePassword_button-group__HBphq`,
	"btn": `changePassword_btn__4Mbvz`,
	"cancel-btn": `changePassword_cancel-btn__5MArm`,
	"save-btn": `changePassword_save-btn__Immee`,
	"change-password-container": `changePassword_change-password-container__7UeXt`,
	"change-password-title": `changePassword_change-password-title__nYget`,
	"change-password-subtitle": `changePassword_change-password-subtitle__c9ZeL`,
	"change-password-content": `changePassword_change-password-content__gUybQ`,
	"password-form": `changePassword_password-form__bmvQl`,
	"form-group": `changePassword_form-group__eoEoq`,
	"form-control": `changePassword_form-control__lh7b+`,
	"error-text": `changePassword_error-text__xB5jB`,
	"password-rules": `changePassword_password-rules__cLfOj`
};
export default ___CSS_LOADER_EXPORT___;
